import { Component, OnInit, inject } from "@angular/core";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { WopiDebugDataService } from "./services/wopi-debug-data.service";
import { MenuSystemDirective } from "@app/shared/directives/menu-system.directive";
import { ProofKeyInfoComponent } from "./components/proof-key-info/proof-key-info.component";
import { LockInfoComponent } from "./components/lock-info/lock-info.component";
import { DiscoveryInfoComponent } from "./components/discovery-info/discovery-info.component";
import { TransactionInfoComponent } from "./components/transaction-info/transaction-info.component";

@Component({
    selector: "wopi-debug",
    templateUrl: "./wopi-debug.component.html",
    styleUrls: ["./wopi-debug.component.scss"],
    imports: [
        MenuSystemDirective,
        ProofKeyInfoComponent,
        LockInfoComponent,
        DiscoveryInfoComponent,
        TransactionInfoComponent,
    ],
})
export class WopiDebugComponent implements OnInit {
    private _ds = inject(WopiDebugDataService);

    tab: TabModel;
    enabled: boolean;

    async ngOnInit() {
        await this.init();
    }

    async init() {
        this.enabled = await this._ds.enabled();
    }
}
